import { memo } from 'react'
import styled from 'styled-components'
import { Figure } from '@/components/base/Figure'
import { TypeCmsMediumImage } from '@/schema'

type ContentTypeImage = {
  col: { from: number, expand: number },
  row: { from: number, expand: number },
  media: TypeCmsMediumImage,
  alt: string,
  caption?: string,
  type: 'image' | 'media',
  imageCaption?: string
  mediaSize?: 'small' | 'medium' | 'big'
}

interface IContentImage {
  data: ContentTypeImage
}

export const ContentImage = memo(({ data }: IContentImage) => {
  const { media } = data
  const { image } = media

  return (
    <Fig media={image} />
  )
})

const Fig = styled(Figure)`
  height: auto;
  width: 100%;

  > span {
    position: relative !important;
    height: auto;
    width: 100%;
  }

  img {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
  }
`
